import PropTypes from 'prop-types';
import { Modal, Button } from '@figure/frontlib-gui';

const isIOS = () => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
/**
 * Modal displayed when user's browser does not support all required features.
 */
const FeatureDetectionModal = (props) => (
  <Modal header="You seem to be using an unsupported browser or have cookies disabled" isOpen={props.isOpen} onClose={props.onClose}>
    <p>
      Figure uses cutting-edge browser features to be able to deliver the best experience to our customers. Unfortunately, that means
      that many browsers are not supported. We recommend you use the newest version of {isIOS() ? 'iOS and Safari' : 'Google Chrome'}{' '}
      and have cookies enabled.
    </p>
    {!isIOS() && (
      <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
        <Button primary large center>
          Download Google Chrome
        </Button>
      </a>
    )}
  </Modal>
);

FeatureDetectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FeatureDetectionModal;
